import { getMemberId } from '@trello/authentication';

// TODO: Remove this legacy key after 2025-04-30
export const getLegacyJiraInvitePermissionsStorageKey = (cloudId: string) =>
  `${getMemberId()}-${cloudId}-inviteToJiraPermissions`;

export const getJiraInvitePermissionsStorageKey = (cloudId: string) =>
  `inviteToJiraPermissions-${getMemberId()}-${cloudId}`;
